import { WrapperBanner } from 'components/product/banner';
import React from 'react';
import style from './index.module.scss';
import cn from 'classnames';
import Transition from 'components/transition';

interface IProps {
  pcUrl: string;
  mUrl: string;
  features: string[];
  IMG_PREFIX: string;
  title: string;
  desc: string;
  type?: string;
  rightImg?: string;
}

const NewProFeatures = (props: IProps) => {
  const { pcUrl, mUrl, features = [], IMG_PREFIX, title, desc, type = '', rightImg = '' } = props;
  return (
    <WrapperBanner
      bannerInfo={{
        pcUrl: IMG_PREFIX + pcUrl,
        mUrl: IMG_PREFIX + mUrl,
        classNames: ` ${style.banner} ${style[type]}`,
      }}
    >
      <Transition delay={0.5}>
        <div className={style.header}>
          <div className={style.left}>
            <div className={style.title}>{title}</div>
            <div className={style.desc}>{desc}</div>
          </div>
          {rightImg && <img src={`${IMG_PREFIX}${rightImg}`} alt="AMS1000" />}
        </div>
      </Transition>
      <Transition delay={0.8}>
        <div className={cn(style.features, type === 'mcu' && style.mcuFeatures)}>
          {features.map((desc: string, index: number) => {
            return (
              <div key={desc} className={style.feature}>
                <img src={`${IMG_PREFIX}${type}_${index + 1}.png`} alt="advantage" />
                <span className={style.detailDesc}>{desc}</span>
              </div>
            );
          })}
        </div>
      </Transition>
    </WrapperBanner>
  );
};

export default NewProFeatures;
